window.AQAAFAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    self.saveJobScreeningForms = function (brandId, jobId, screeningForms) {
        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/jobs/' + jobId + '/screening_forms', 'PUT', {
            screening_forms: screeningForms
        }).then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            }
            else {
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.getJobScreeningForms = function (brandId, jobId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/screening_forms', 'GET', {})
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getJobScreeningFormDetails = function (brandId, jobId, setId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/screening_forms/' + setId, 'GET', {})
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getScreeningForms = function (brand_id, job_id, screening_forms_id, form_type) {

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'applicants/brands/' + brand_id + '/jobs/' + job_id + '/screening_forms/' + screening_forms_id + '/questions', 'GET', {})
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res.data);
                }
            }, function (err) {
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    self.checkJobScreeningFormDeletionAllowed = function (brandId, jobId, formId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/screening_forms/' + formId + '/check_deletion', 'GET', {})
            .then(function (res) {
            if (res && res.data && res.data.data && res.data.status_code == 200) {
                deferred.resolve(res.data.data);
            }
            else {
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };
});
